import Layout from 'components/Layout';
import Favorites from 'components/Favorites';
import FavoritesSubNav from 'components/Favorites/SubNav';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFavorites from 'lib/hooks/useFavoritePresenters';
import useFetchFavorites from 'lib/hooks/useFetchFavorites';
import useFetchLeads from 'lib/hooks/useFetchLeads';
import CarGurusAdUnit from 'lib/CarGurusAds/AdUnit';
import { AgeType, PageType, Zone } from 'lib/CarGurusAds/TaxonomySchema';
import useAdSetup from 'lib/hooks/useAdSetup';
import { GetServerSideProps } from 'next';
import isIndexable from 'lib/isIndexable';

interface PageProps {
  indexable: boolean;
}

const FavoritesPage = ({ indexable }: PageProps): JSX.Element => {
  const { t } = useTranslation();
  const { requestState } = useFetchFavorites(true);
  useFetchLeads();
  const { favorites } = useFavorites();
  const priceDrops = favorites.filter((f) => f.hasPriceDroppedSinceFavoriting);
  const [isFavoritesActive, setIsFavoritesActive] = useState(true);
  const adUnit = new CarGurusAdUnit({ zone: Zone.Homepage });
  useAdSetup(adUnit.toString(), {
    make: null,
    model: null,
    year: null,
    pageType: PageType.Favorites,
    ageType: AgeType.None,
    cpo: false,
    inLine: 1,
    body_style: null,
    category: null,
    app: 'web',
    sellerId: null,
  });

  const subNav = (
    <FavoritesSubNav
      favoritesCount={favorites.length}
      priceDropsCount={priceDrops.length}
      isFavoritesActive={isFavoritesActive}
      onFavoritesList={setIsFavoritesActive}
    />
  );
  return (
    <Layout subNav={subNav} title={t('favorites.title')} description="" indexed={indexable}>
      <Favorites
        favorites={isFavoritesActive ? favorites : priceDrops}
        isFavoritesActive={isFavoritesActive}
        requestState={requestState}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps<PageProps> = async ({ req }) => {
  const indexable = isIndexable(req);
  return { props: { indexable } };
};

export default FavoritesPage;
